import Component from './Component';
import { getConfig, UserManager, checkLoginGetStatus, logoutRemote, logoutLocal, getUser, getAccessTokenOrSignin } from '../lib/OidcHelper';
import {showMessageboxModal} from "../lib/TripPlannerHelper";
// Also uses window.props created by PreferenceMenu.js

export default class PreferenceHeadBtn extends Component {
  load() {
    this.initCheckIfLoggedIn();
    this.initPreferenceHeadBtn();
    super.load();
  }

  // display logout button IF logged in, ELSE display login button.
  async initCheckIfLoggedIn() {
    // Check Login Status and get "user" and "token".
    let user, token;  // define variables we will destructure into.
    ({ user, token } = await checkLoginGetStatus()); // destructuring object returned into variables.

    if (!token) { // no token
      console.log('not logged in.');
      $('.js-prefcentre-head-logout').not('.global-hidden').addClass('global-hidden');
      $('.js-prefcentre-head-profile').not('.global-hidden').addClass('global-hidden');
      $('.js-prefcentre-head-settings').not('.global-hidden').addClass('global-hidden');

      // Add popup on use of favorites
      const favourites = $('.js-prefcentre-head-favourites');
      favourites.attr("href", '#');
      favourites.on('click', () => showMessageboxModal('#msgboxModalUpsell'));
    } else {
      console.log('not logged in.');
      $('.js-prefcentre-head-profile.global-hidden').removeClass('global-hidden');
      $('.js-prefcentre-head-favourites.global-hidden').removeClass('global-hidden');
      $('.js-prefcentre-head-settings.global-hidden').removeClass('global-hidden');
      $('.js-prefcentre-head-login').not('.global-hidden').addClass('global-hidden');
      $('.js-prefcentre-head-favourites').on('click', goFavourites);
      $('.js-prefcentre-head-settings').on('click', goSettings);
      $('.js-prefcentre-head-profile').on('click', goProfile);
      $('.js-prefcentre-head-logout').on('click', goLogout);
      $('#signout').remove();  // remove signout iframe if it exists.
    }
  }

  initPreferenceHeadBtn() {
    const thisCont = this;

    // add event listeners to the preference head buttons.
    $('.js-prefcentre-head-login').on('click', function (e) {
      console.log('login');
      doLogin();
    });

    // $('.js-prefcentre-head-logout').on('click', function (e) {
    //   console.log('log out locally..');
    //   logoutLocal();
    //   $('.header-prefcentre__menu').removeClass('header-prefcentre__menu--active'); // close menu
    // });


    // create a dropdown the user button
    $('.js-preference-head-btn').on('click', function (e) {
      // e.preventDefault();

      $('.header-prefcentre__menu').toggleClass('header-prefcentre__menu--active');

      let menuActive = $('.header-prefcentre__menu--active');
      console.log('menuActive: ', menuActive);
      if (menuActive && menuActive.length > 0) {
        // add listener but don't trigger immediately
        listenForOutsideClicks(); // use for close menu
      }
      // e.stopPropagation();

    });


    function listenForOutsideClicks() {

      $(document).on('click', function (ev) {
        // console.log('ev.target: ', ev.target);
        // console.log('ev.targetcheck_1: ', ev.target.closest(".header-prefcentre__menu"));
        // console.log('ev.targetcheck_2: ', ev.target.closest(".js-preference-head-btn"));
        if ((ev.target.closest(".header-prefcentre__menu") == null) && (ev.target.closest(".js-preference-head-btn") == null)) {
          //only close menu if clicked outside menu and menu button
          $(document).off('click'); // remove listener
          $('.header-prefcentre__menu').removeClass('header-prefcentre__menu--active'); // close menu
        }
      });
    }

    // initTabFromUrlHash(); // init tab from url hash on load. The problem is this one needs to occur after login checks have completed.

  }

}


async function doLogin() {

  const config = getConfig(window.location);
  let oidcUserManager = new UserManager(config);

  let user = await getUser(oidcUserManager);

  if (!user) {
    console.log('not logged in.');

    // should trigger a login redirect
    const token = await getAccessTokenOrSignin(oidcUserManager);
    if (token == null) {
      console.log('no token.');
    } else {
      // got a token so show update view to reflect logged in status/trigger a reload?
      console.log('not logged in.');
      $('.js-prefcentre-head-logout').show();
      $('.js-prefcentre-head-login').hide();
      $('.js-prefcentre-head-profile').hide();
      $('.js-prefcentre-head-settings').hide();
    }

  }
}

function goFavourites() {
  console.log('goFavourites');
  window.location.hash = '#favourites';
  initTabFromUrlHash();
}

function goSettings() {
  console.log('goSettings');
  window.location.hash = '#settings';
  initTabFromUrlHash();
}

function goProfile() {
  console.log('goProfile');
  window.location.hash = '#profile';
  initTabFromUrlHash();
}

function goLogout() {
  console.log('goLogout.   logout ');
  logoutRemote();
  logoutLocal();  // logout local will also cleanup storage.

  $('.js-prefcentre-head-logout').hide();
  $('.js-prefcentre-head-profile').hide();
  $('.js-prefcentre-head-settings').hide();
  $('.js-prefcentre-head-login').show();
  window.location.hash = '#favourites';
  initTabFromUrlHash(); // will change tab to favourites.
  $('.header-prefcentre__menu').removeClass('header-prefcentre__menu--active'); // close menu
  //set profile and settings tabs to disabled if in DOM.
  document.querySelector('[data-title="Profile"]') ? document.querySelector('[data-title="Profile"]').setAttribute("disabled", true) : null;
  document.querySelector('[data-title="Settings"]') ? document.querySelector('[data-title="Settings"]').setAttribute("disabled", true) : null;
}


function initTabFromUrlHash() {

  console.log('window.panelProps', window.panelProps);

  let props = window.panelProps;
  let changePanel = window.panelProps.changePanel;
  console.log('initTabFromUrlHash');

  // if url hash contains a valid tab then changePanel
  let urlHash = window.location.hash;
  console.log('urlHash: ', urlHash);

  if (urlHash === '#settings') {
    let menuItemSettings = document.querySelector('[data-title=Settings]');
    changePanel(menuItemSettings, props.sliderUlWidth, props.slideWidth);
  } else if (urlHash === '#profile') {
    let menuItemProfile = document.querySelector('[data-title=Profile]');
    changePanel(menuItemProfile, props.sliderUlWidth, props.slideWidth);
  } else if (urlHash === '#favourites') {
    let menuItem = document.querySelector('[data-title=Favourites]');
    changePanel(menuItem, props.sliderUlWidth, props.slideWidth);
  }
  console.log('hash changePanel' + urlHash);
  $('.header-prefcentre__menu').removeClass('header-prefcentre__menu--active'); // close menu
}
